/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_TitleInputs */

const en_mk_agent_title = /** @type {(inputs: Mk_Agent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents that do the work, not suggest it`)
};

const id_mk_agent_title = /** @type {(inputs: Mk_Agent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen yang benar-benar mengerjakan, bukan menyarankan`)
};

/**
* | output |
* | --- |
* | "Agents that do the work, not suggest it" |
*
* @param {Mk_Agent_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_title = /** @type {((inputs?: Mk_Agent_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_title(inputs)
	return en_mk_agent_title(inputs)
});